const SuccessActionType = {
  FETCH_ARTICLES: 'FETCH_SUPPORT_ARTICLES',
  STORE_ARTICLES: 'STORE_SUPPORT_ARTICLES',
  FETCH_CATEGORIES: 'FETCH_SUPPORT_CATEGORIES',
  STORE_CATEGORIES: 'STORE_SUPPORT_CATEGORIES',
};

export default SuccessActionType;



/** WEBPACK FOOTER **
 ** ./src/common/SupportActionType.js
 **/